import PropTypes from "prop-types"
import React, { useState } from "react"
import { Row, Col, Card, CardBody, Container, Label } from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from "formik"

//redux
import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

// action
import { userForgetPassword } from "../../store/actions"

import logo from "../../assets/images/logo.svg"
import {
  resetPasswordSchema,
  verifyOTPSchema,
  verifyPasswordSchema,
} from "components/Common/validation"
import { changePassword, verifyOtp } from "store/actions/authAction"
import { showAlert } from "store/reducers/alertReducer"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const VerifyPassword = props => {
  const { t } = useTranslation()
  //meta title
  document.title = t("Verify Password | Namq")

  const [tempOtp, TempOtp] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const dispatch = useDispatch()

  const {
    loading,
    verifyPasswordStep,
    verifyPasswordError,
    changePasswordError,
    varifyPasswordSuccesMsg,
    changePasswordSuccessMsg,
    error,
    message,
    actionType,
  } = useSelector(state => state.Login)
  // console.log(verifyPasswordStep)
  const handleOtpVerify = values => {
    const forgotEmail = sessionStorage.getItem("forgotEmail")
    const payload = {
      email: forgotEmail,
      otp: values.otp,
    }
    TempOtp(values.otp)
    dispatch(verifyOtp({ ...payload, history: props.router.navigate })).then(
      action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      }
    )
  }

  const handlePasswordChange = values => {
    const forgotEmail = sessionStorage.getItem("forgotEmail")
    const { newPassword, confirmPassword } = values
    const payload = {
      email: forgotEmail,
      otp: tempOtp,
      newPassword,
      confirmPassword,
    }
    dispatch(changePassword({ ...payload, history: props.router.navigate }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col xs={12}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">{t("Welcome Back")} !</h5>
                        <p>{t("Sign in to continue to Namq.")}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {verifyPasswordStep === "NEW_PASSWORD" ? (
                      <Formik
                        enableReinitialize={true}
                        initialValues={{ newPassword: "", confirmPassword: "" }}
                        validationSchema={verifyPasswordSchema}
                        onSubmit={handlePasswordChange}
                      >
                        {({ values, errors, touched, isSubmitting }) => (
                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("New Password")}
                              </Label>
                              <div className="position-relative">
                                <Field
                                  name="newPassword"
                                  className={`form-control ${
                                    touched.newPassword &&
                                    errors.newPassword &&
                                    "is-invalid"
                                  }`}
                                  placeholder={t("New Password")}
                                  type={showPassword ? "text" : "password"}
                                />
                                <i
                                  onClick={() => setShowPassword(!showPassword)}
                                  className={`bx bx-${
                                    showPassword ? "show-alt" : "hide"
                                  } common_eye`}
                                ></i>
                              </div>
                              <TextError name="newPassword" />
                            </div>
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("Confirm Password")}
                              </Label>
                              <div className="position-relative">
                                <Field
                                  name="confirmPassword"
                                  className={`form-control ${
                                    touched.confirmPassword &&
                                    errors.confirmPassword &&
                                    "is-invalid"
                                  }`}
                                  placeholder={t("Confirm Password")}
                                  type={
                                    showConfirmPassword ? "text" : "password"
                                  }
                                />
                                <i
                                  onClick={() =>
                                    setShowConfirmPassword(!showConfirmPassword)
                                  }
                                  className={`bx bx-${
                                    showConfirmPassword ? "show-alt" : "hide"
                                  } common_eye`}
                                ></i>
                              </div>
                              <TextError name="confirmPassword" />
                            </div>
                            <Row className="mb-3">
                              <Col className="text-end">
                                <button
                                  className="btn btn-primary w-md "
                                  type="submit"
                                  disabled={isSubmitting}
                                >
                                  {t("Save")}
                                </button>
                              </Col>
                            </Row>
                          </Form>
                        )}
                      </Formik>
                    ) : (
                      <Formik
                        enableReinitialize={true}
                        initialValues={{ otp: null }}
                        validationSchema={verifyOTPSchema}
                        onSubmit={handleOtpVerify}
                      >
                        {({ values, errors, touched, isSubmitting }) => (
                          <Form className="form-horizontal">
                            <div className="mb-3">
                              <Label className="form-label">
                                {t("Verify OTP")}
                              </Label>
                              <Field
                                name="otp"
                                className={`form-control ${
                                  touched.otp && errors.otp && "is-invalid"
                                }`}
                                placeholder={t("Verify OTP")}
                                type="text"
                              />
                              <TextError name="otp" />
                            </div>
                            <Row className="mb-3">
                              <Col className="text-end">
                                <button
                                  className="btn btn-primary w-md "
                                  type="submit"
                                  disabled={loading}
                                >
                                  {t("Verify")}
                                </button>
                              </Col>
                            </Row>
                          </Form>
                        )}
                      </Formik>
                    )}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  {t("Go back to")}{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    {t("Login")}
                  </Link>{" "}
                </p>
                {/* <p>
                  © {new Date().getFullYear()} Skote. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

VerifyPassword.propTypes = {
  history: PropTypes.object,
}

export default withRouter(VerifyPassword)
